import { For, Show } from "solid-js";
import { OrgMark } from "~/components/OrgMark";
import { StatusPill } from "~/components/StatusPill";
import type { CompanyCard as CompanyCardData } from "~/lib/api";
import { communityLine, isSponsorRelationship, stackPreview } from "~/lib/company-stack";

type Props = {
  card: CompanyCardData;
  featured?: boolean;
  onOpen: (card: CompanyCardData) => void;
};

export function CompanyCard(props: Props) {
  const preview = () => stackPreview(props.card.stack);
  const eyebrow = () =>
    [props.card.sector, props.card.locations].filter(Boolean).join(" · ") || "Community company";
  const counts = () => communityLine(props.card);
  const sponsor = () => isSponsorRelationship(props.card.deb_relationship);

  return (
    <button
      type="button"
      class={`company-card${props.featured || props.card.hiring ? " company-card--accent" : ""}`}
      onClick={() => props.onOpen(props.card)}
    >
      <div class="company-card-top">
        <OrgMark name={props.card.canonical_name} />
        <span class="company-card-eyebrow">{eyebrow()}</span>
        <span class="company-card-status">
          <Show when={props.card.hiring}>
            <StatusPill variant="hiring" />
          </Show>
          <Show when={!props.card.hiring && sponsor()}>
            <StatusPill variant="sponsor" />
          </Show>
        </span>
      </div>
      <strong class="company-card-name">{props.card.canonical_name}</strong>
      <Show when={counts()}>
        <span class="muted">{counts()}</span>
      </Show>
      <Show when={preview().length}>
        <div class="company-card-tags">
          <For each={preview()}>{(tag) => <span class="skill-chip">{tag}</span>}</For>
        </div>
      </Show>
    </button>
  );
}
